var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 70,
    viewBox: "0 0 45 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1154 56.4586L27.2987 28.0803L21.3674 26.2207L6.42676 56.9172L11.8609 65.8725L16.4461 56.6703H31.6018L35.0902 64.0876L37.9119 63.3723L41.114 56.4572L41.1154 56.4586ZM19.5356 49.3348L23.8829 39.8815L28.2302 49.3348H19.537H19.5356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLetter);
export default __webpack_public_path__ + "static/media/logo_letter.c622fbd44dfd4e0284fb2507c5a921d7.svg";
export { ForwardRef as ReactComponent };